// Steam OpenID login entry points for the LMUTV storefront.
//
// The same build serves the SRS hub and LMUTV: LMUTV lives at "/lmutv" on the
// hub and at "/" on the standalone lmutv.* host. The PHP handler returns the
// user to whatever `ret` path we pass, so compute the LMUTV base for this
// deployment and always use an absolute /dyn path (relative paths break under
// the /lmutv subpath).

export function lmuTvBasePath(): string {
  return window.location.pathname.startsWith("/lmutv") ? "/lmutv" : "/";
}

export function steamLoginUrl(cart = false): string {
  const ret = encodeURIComponent(lmuTvBasePath());
  return `/dyn/auth/init-openId.php?ret=${ret}${cart ? "&cart" : ""}`;
}

export function steamLogin(cart = false): void {
  window.location.href = steamLoginUrl(cart);
}
